import React from 'react';
export const Lips: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.298"
      height="18"
      fill="currentColor"
      {...props}
    >
      <g fill="currentColor">
        <path
          data-name="Path 21757"
          d="M16.258 3.682a.349.349 0 00-.33-.234h-3.8a.35.35 0 00-.33.234 24.357 24.357 0 000 14.084.35.35 0 00.33.234h3.8a.349.349 0 00.33-.234 24.357 24.357 0 000-14.084zm-3.88.465h3.3a21.474 21.474 0 01.919 6.228H11.46a21.47 21.47 0 01.918-6.228zm3.3 13.154h-3.3a19.571 19.571 0 01-.835-4.432h1.311a.35.35 0 100-.7h-1.359q-.029-.543-.036-1.1h5.137a21.474 21.474 0 01-.919 6.232z"
        />
        <path
          data-name="Path 21758"
          d="M8.162 9.659H7.17V5.864a.349.349 0 00-.349-.35h-.8V2.57A3.242 3.242 0 004.428.046a.349.349 0 00-.352 0A3.242 3.242 0 002.483 2.57v2.944h-.8a.35.35 0 00-.35.35v3.795H.341a.349.349 0 00-.349.349 24.087 24.087 0 001.174 7.764.349.349 0 00.327.227h5.509a.35.35 0 00.327-.227 24.083 24.083 0 001.174-7.764.349.349 0 00-.341-.349zM3.186 2.571a1.218 1.218 0 112.14 0v2.944h-2.14zM2.041 6.214h4.43v3.445h-4.43zm4.725 11.087H1.747a20.844 20.844 0 01-.932-4.772h2.022a.35.35 0 100-.7H.76a27.727 27.727 0 01-.058-1.471h7.109a23.6 23.6 0 01-1.046 6.943z"
        />
      </g>
    </svg>
  );
};
